/* global google */
define('views/pages/wishlist/wishes/page',['require','underscore','jquery','views/base/page','text!templates/pages/wishlist/wishes/page.ejs','models/base/model','models/base/collection','models/pages/wishlist/wishes/modal/index','views/pages/wishlist/wishes/modal/index'],function(require) {
    'use strict';

    var _ = require('underscore'),
        $ = require('jquery'),
        PageView = require('views/base/page'),
        template = require('text!templates/pages/wishlist/wishes/page.ejs'),

        Model = require('models/base/model'),
        Collection = require('models/base/collection'),

        WishlistModalModel = require('models/pages/wishlist/wishes/modal/index'),
        WishListModalView = require('views/pages/wishlist/wishes/modal/index');

    var WishlistPageView = PageView.extend({
        autoRender: true,
        template: template,
        region: 'wishes',
        regions: {
            'wishlist-table': '.wishlist'
        },
        listen: {
            'resize model': 'onResize',
            'afterLoad model': 'onResize',
            'addedToDOM': 'onAddedToDOM'
        },
        events: {
            'click .wishlist-item-header': 'expandOrCollapse',

            'click .open-goods-card': 'showBuyModal',

            'click .wishlist-buy button': 'showBuyModal',
            'click .wishlist-detail-expanded .btn-link': 'closeDetail',
            'click table a': 'openDetail',


            'click .expand-legend button': 'expandLegend',

            'click #add-button': 'openCreateModal'
        },

        windowResize: true,

        openCreateModal: function() {
            var model = this.model;

            var modalModel = new WishlistModalModel({ active: true });

            this.subview('editModal', new WishListModalView({ model: modalModel }));

            modalModel.load();

            modalModel.on('saved', function(action, cancel) {
                model.items.fetch();

                modalModel.dispose();
            });
        },

        onAddedToDOM: function() {
            this.model.trigger('resize');


            $('.map-show').click(function(e) { e.preventDefault();
                $('.map-container').addClass('expanded');
                $('.map-show').addClass('hidden');
                $('.map-hide').removeClass('hidden');
            });

            $('.map-hide').click(function(e) { e.preventDefault();
                $('.map-container').removeClass('expanded');
                $('.map-hide').addClass('hidden');
                $('.map-show').removeClass('hidden');
            });


            $('.table-show').click(function(e) { e.preventDefault();
                $('.table-container').addClass('expanded');
                $('.table-show').addClass('hidden');
                $('.table-hide').removeClass('hidden');
            });

            $('.table-hide').click(function(e) { e.preventDefault();
                $('.table-container').removeClass('expanded');
                $('.table-hide').addClass('hidden');
                $('.table-show').removeClass('hidden');
            });

            $('.trade-table-seller a, .card-organization .close, .card-organization .modal-footer button').click(function() {
                $('.card-organization').toggleClass('hidden');
            });
        },

        expandLegend: function() {
            this.$('.expand-legend').toggleClass('expanded');
        },

        render: function() {
            PageView.prototype.render.apply(this, arguments);

            // var $items = this.$('.wishlist-item');

            // var delay = 100;
            // $items.each(function() {
            //     var $item = $(this);
            //     setTimeout(function() {
            //         $item.animate({ 'margin-left': '0px', 'margin-right': '0px' });
            //     }, delay);
            //     delay = delay + 100;
            // });


            // var $notify = this.$('.notify');

            // setTimeout(function() {
            //     $notify.addClass('show');

            //     setTimeout(function() {
            //         $notify.animate({ opacity: 0 });
            //     }, 10000);
            // }, 2000);
        },

        closeNotify: function() {
            var $notify = this.$('.notify');
            $notify.removeClass('show');
        },
        onResize: function() {
            // var h = $('body').height();
            // var t = this.$el.position().top;
            // this.$el.height(h - t - 260);
        },

        // toggleEditModal: function() {
        //     var container = this.$('.wishlist-price-edit');

        //     var hidden = container.hasClass('hidden');
        //     if (hidden) {
        //         container.find('.modal-backdrop').css('opacity', 0);
        //         container.find('.modal').css('margin-top', '-1000px');
        //         container.removeClass('hidden');

        //         container.find('.modal').animate({ 'margin-top': '0px' }, 250, function() {
        //             container.find('.modal-backdrop').animate({ opacity: 1 }, 250, function() {
        //             });
        //         });

        //     } else {
        //         container.find('.modal').animate({ 'margin-top': '-1000px' }, 250, function() {
        //             container.find('.modal-backdrop').animate({ opacity: 0 }, 250, function() {
        //                 container.addClass('hidden');
        //             });
        //         });
        //     }

        // },

        showDetailModal: function() {
            var container = this.$('.wishlist-price-edit');

            var hidden = container.hasClass('hidden');
            if (hidden) {
                container.find('.modal-backdrop').css('opacity', 0);
                container.find('.modal').css('margin-top', '-1000px');
                container.removeClass('hidden');

                container.find('.modal').animate({ 'margin-top': '0px' }, 250, function() {
                    container.find('.modal-backdrop').animate({ opacity: 1 }, 250, function() {
                    });
                });

            } else {
                container.find('.modal').animate({ 'margin-top': '-1000px' }, 250, function() {
                    container.find('.modal-backdrop').animate({ opacity: 0 }, 250, function() {
                        container.addClass('hidden');
                    });
                });
            }

        },
        showBuyModal: function() {
            var container = this.$('.wishlist-buy');

            var hidden = container.hasClass('hidden');
            if (hidden) {
                container.find('.modal-backdrop').css('opacity', 0);
                container.find('.modal').css('margin-top', '-1000px');
                container.removeClass('hidden');

                container.find('.modal').animate({ 'margin-top': '0px' }, 250, function() {
                    container.find('.modal-backdrop').animate({ opacity: 1 }, 250, function() {
                    });
                });

            } else {
                container.find('.modal').animate({ 'margin-top': '-1000px' }, 250, function() {
                    container.find('.modal-backdrop').animate({ opacity: 0 }, 250, function() {
                        container.addClass('hidden');
                    });
                });
            }

        },
        openDetail: function(e) {
            e.preventDefault();

            this.$('.wishlist').addClass('pull-back');
            this.$('.wishlist-detail-expanded').animate({ 'margin-left': '0px', 'margin-right': '0px' });
        },
        closeDetail: function() {
            this.$('.wishlist').removeClass('pull-back');
            this.$('.wishlist-detail-expanded').animate({ 'margin-left': '-2000px', 'margin-right': '2000px' });
        },
        expandOrCollapse: function(ev) {
            if ($(ev.target).hasClass('icon-plus')) {
                this.showDetailModal();
                return;
            }

            var $item = $(ev.currentTarget).parent();

            var active = $item.hasClass('active');

            var $detail = $item.find('.wishlist-detail');

            $item.toggleClass('active');
            if (active) {
                $detail.animate({ 'max-height': 0 }, function() {
                });
            } else {
                var detailItems = $detail.find('.wishlist-detail-item');
                $detail.animate({ 'max-height':  detailItems.length * 26 }, function() {
                    // $item.addClass('active');
                });
            }
        }
    });

    return WishlistPageView;
});

